<template>
  <div class="bc-body">
    <!-- <van-nav-bar class="nav-bar" fixed placeholder>
      <template #left>
        <img
          :src="
            $store.getters.getBaseInfo.ico !== undefined
              ? $store.getters.getBaseInfo.ico
              : '/img/null.png'
          "
        />
      </template>
      <template #right>
        <img
          @click="$router.push('/Mine')"
          class="w2"
          src="/img/home/shuju.png"
          alt=""
        />
      </template>
    </van-nav-bar> -->
    <!-- 头部 -->
    <div class="top">
      <div class="font">{{ $t("foorter.subscribe") }}</div>
      <!-- <img
        @click="$router.push('/Mine')"
        class="w2"
        src="/img/home/shuju.png"
        alt=""
      /> -->
      <div class="img">
        <van-icon
          name="chat-o"
          @click="kefu()"
          size="1.7rem"
          style="font-weight: lighter !important"
        />
      </div>
    </div>
    <!-- 标题 -->
    <div class="bc-title">
      <p class="p1">{{ $t("history.p1") }}</p>
    </div>
    <div class="bc-title2">
      <div class="p2">
        <span>{{ $t("history.Black_material") }}</span
        >{{ $t("history.p2") }}
      </div>
    </div>
    <div class="bc-title3">
      {{ $t("history.p3") }}
    </div>
    <!-- 搜索 -->
    <div class="bc-search">
      <van-search
        v-model="value"
        :placeholder="$t('history.search')"
        background="none"
        shape="round"
        :clearable="false"
        @search="search"
      >
        <template #right-icon>
          <img
            src="/img/home/search.png"
            alt=""
            @click="search"
            class="search-icon"
          />
        </template>
      </van-search>
    </div>
    <!-- 状态 -->
    <div class="bc-state">
      <div class="state">
        <div style="color: #feb974; font-weight: lighter !important">
          {{ $t("history.Featured") }}
        </div>
        <div style="font-size: 1.2rem">{{ pagelist.length }}</div>
        <div style="color: #ccc; font-weight: lighter !important">
          {{ $t("history.Breaking") }}
        </div>
      </div>
      <div class="state">
        <div style="color: #feb974; font-weight: lighter !important">
          {{ $t("history.current_status") }}
        </div>
        <div style="font-size: 1.2rem" v-if="userInfo.vip == 0">{{ $t('Unauthenticated') }}</div>
        <div style="font-size: 1.2rem" v-else>{{ $t('Certified') }}</div>
        <div style="color: #ccc; font-weight: lighter !important">
          {{ $t("history.loading") }}
        </div>
      </div>
    </div>
    <!-- 内容标题 -->
    <div class="bc-hot">
      <div class="hot-title">{{ $t("history.Channel") }}</div>
      <div>{{ $t("history.scandals_never") }}</div>
    </div>

    <!-- 内容列表 -->
    <div style="padding-bottom: 4rem;">
      <div
        class="bc-text"
        @click="toast()"
        v-for="(item, index) in renderList"
        :key="index"
      >
        <!-- <img :src="getImageUrl(item.image)" alt="" /> -->
        <img :src="item.image" alt="" />

        <div class="bc-zz"></div>
        <div class="img-color">
          <div class="time">
            <div class="font">{{ $t("history.Private") }}</div>
            <div class="font1">{{ item.create_time || "" }}</div>
          </div>
          <div class="body">
            {{ item.cn_title || item.cn_desc }}
          </div>
          <div class="text">
            <div style="display: flex; justify-content: left">
              <div class="font2">
                {{ item.cn_keys }}
              </div>
              <div class="font2">
                {{ $t("history.scandals_never") }}
              </div>
            </div>
            <div class="time2">
              <div class="btn">{{ $t("history.play") }}</div>
              <div
                style="
                  font-size: 0.6rem;
                  font-weight: lighter !important;
                  color: #ccc;
                "
              >
                {{ $t("history.receive") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 无数据提示 -->
    <div
      v-if="renderList.length === 0"
      style="color: #fff; text-align: center; padding: 2rem 0"
    >
      {{ value || $t("history.none") }}
    </div>

    <!-- ======================
    🔥 只改这里：永远显示分页（只要大于1页就显示）
    ======================= -->
    <div style="padding: 0 0.5rem" v-if="!value && totalItems > 6">
      <van-pagination
        v-model="currentPage"
        mode="simple"
        :total-items="totalItems"
        :items-per-page="6"
        @change="getpagelist"
        :prev-text="$t('history.prev')"
        :next-text="$t('history.next')"
      >
      </van-pagination>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.applyCachedHistoryData();
    this.getpagelist();
    this.getUserInfo()
  },
  data() {
    return {
      value: "",
      userInfo:'',
      currentPage: 1,
      pagelist: [],
      catelist: [],
      totalItems: 0,
      baseUrl: process.env.VUE_APP_IMG_URL || "https://admin.aiacstu.com",
    };
  },
  computed: {
    renderList() {
      if (this.value.trim() !== "" && this.catelist.length > 0) {
        return this.catelist;
      }
      return this.pagelist;
    },
  },
  methods: {
    applyCachedHistoryData() {
      const cache = localStorage.getItem("history_page_cache");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.pagelist = Array.isArray(parsed.pagelist) ? parsed.pagelist : [];
        this.totalItems = parsed.totalItems || this.totalItems;
        return true;
      } catch (error) {
        return false;
      }
    },
    persistHistoryData() {
      localStorage.setItem(
        "history_page_cache",
        JSON.stringify({
          pagelist: this.pagelist,
          totalItems: this.totalItems,
        })
      );
    },
    kefu(){
     this.$toast(this.$t("Universal.personal")); 
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
        data: {
          type: 1,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;

          this.menu_top = 15;
          /* if (this.userInfo.status !== 1) {
						this.$toast(this.$t("video.account_out"));
						localStorage.clear()
						this.$router.push({
							path: '/Login'
						})
					} */
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    // 万能图片方法
    getImageUrl(img) {
      if (!img) return "../../assets/bc-img/n1.jpg";
      if (img.startsWith("http")) return img;
      return this.baseUrl + img;
    },

    // 搜索
    search() {
      this.catelist = [];
      if (this.value.trim() === "") {
        this.getpagelist();
        return;
      }
      this.getcatelist();
    },

    toast() {
      this.$toast(this.$t("history.kf"));
    },

    // ==============================
    // 真实分页 + 动态获取总条数
    // ==============================
    getpagelist() {
      this.$http({
        method: "get",
        url: "pagelist",
        // data: {
        //   page: this.currentPage,
        //   limit: 8,
        //   cate_id: 1,
        // },
      }).then((res) => {
        if (res.code === 200) {
          try {
            let result =
              typeof res.data.data === "string"
                ? JSON.parse(res.data.data)
                : res.data.data;

            // 列表数据
            this.pagelist = result;
            console.log('文章',this.pagelist );
            
            

            // =======================
            // 🔥 固定总数 7 条
            // =======================
            this.totalItems = 8;
            this.persistHistoryData();
          } catch (e) {
            this.pagelist = [];
            this.totalItems = 0;
          }
        }
      });
    },

    // 🔥🔥🔥 搜索接口（后端要求：不传任何参数）
    getcatelist() {
      this.$http({
        method: "get",
        url: "catelist", // 完整接口地址
        data: {
          cn_keys: this.value,
          // keyword:this.value
        },
      }).then((res) => {
        if (res.code === 200) {
          try {
            let data =
              typeof res.data === "string" ? JSON.parse(res.data) : res.data;
            let list = data.data || data;
            this.catelist = list;
          } catch (e) {
            this.catelist = [];
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "@/assets/css/base.less";
.btn {
  background-color: #f2bb7b;
  color: #000;
  padding: 0.25rem 1.2rem;
  border-radius: 1rem;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
}
.time2 {
  padding: 0.5rem 0;
  font-size: 0.8rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.font {
  color: #ffc57d;
  font-weight: lighter !important;
  font-size: 0.6rem;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.6rem;
  border-radius: 2rem;
  border: 1px solid #989898;
}
.font1 {
  color: #fff;
  font-weight: lighter !important;
  font-size: 0.6rem;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.6rem;
  border-radius: 2rem;
  border: 1px solid #989898;
}
.font2 {
  color: #fff;
  font-weight: lighter !important;
  font-size: 0.6rem;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.6rem;
  border-radius: 2rem;
  border: 1px solid #989898;
  width: auto;
  margin-right: 0.4rem;
}
.bc-hot {
  color: #fff;
  font-size: 1.2rem;
  padding: 0 1rem 0.5rem 0.5rem;
}
.hot-title {
  color: #8c835f;
  font-weight: lighter !important;
  font-size: 0.7rem;
  // padding: 0.5rem 0.5rem 0 0.5rem;
}
.bc-state {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
  margin-bottom: 0.5rem;
  .state {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    background-color: #000;
    width: 49%;
    color: #fff;
    font-size: 0.6rem;
    padding: 1rem 1rem 0.6rem 1rem;
    border-radius: 1rem;
  }
}
.top {
  display: flex;
  width: 100%;
  padding: 1rem 0.5rem 0 0.5rem;
  justify-content: space-between;
  align-items: center;

  .img {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid #6f6f6f;
    border-radius: 0.5rem;
  }
}
::v-deep .van-search {
  // padding-top: 1rem;
  margin: 0.5rem 0;
  padding: 0 0.5rem;
}
::v-deep .van-search__content {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  height: 2.2rem;
  display: flex;
  align-items: center;
}
::v-deep .van-field__left-icon {
  display: none;
}
::v-deep .van-field__control {
  font-size: 0.7rem;
  padding-left: 0.5rem;
  font-weight: lighter !important;
  color: #ccc;
}
::v-deep .van-field__right-icon {
  padding-right: 0.5rem;
}
::v-deep .van-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
}
::v-deep .van-pagination__item {
  width: 10vw !important;
  height: 2.5rem !important;
  background: none !important;
  border-radius: 1rem !important ;
  color: #fff !important;
}
::v-deep .van-pagination__page-desc {
  font-size: 1rem;
  color: #fff;
}
::v-deep .van-pagination__item:active {
  background: none !important;
}

.bc-body {
  padding: 0 0.4rem 20rem 0.4rem !important;
  background: linear-gradient(to bottom right, #4b3739, #3e2c44) !important;
  height: 100vh;
}
.bc-search {
  .search-icon {
    width: 1.5rem;
    height: auto;
  }
}
.bc-title {
  width: 100%;
  height: auto;
  padding: 0.3rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: #fff;
  .p1 {
    font-size: 1.5rem;
    font-weight: 400;
    margin: 0 !important;
    text-align: center;
  }
}
.bc-title2 {
  width: 100%;
  height: auto;
  padding: 0.3rem 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  color: #fff;
  .p2 {
    font-size: 1.4rem;
    margin: 0.2rem 0 !important;
    // text-align: center;
  }
  span {
    background: linear-gradient(to right, #f7b024, #f99219);
    padding: 0.2rem 0.5rem;
    color: #000;
    font-weight: bolder !important;
    border-radius: 0.5rem;
    margin-right: 0.3rem;
  }
}
.bc-title3 {
  width: 100%;
  height: auto;
  padding: 0.3rem 1rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: left;
  color: #e2e2e2;
  font-size: 0.6rem;
  font-weight: lighter !important;
}
.bc-text {
  width: 100%;
  height: 380px;
  padding: 0 0.5rem;
  color: #fff;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 1.5rem;

  img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 1rem;
  }
  .bc-zz {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
    border-radius: 1rem;
  }
  .img-color {
    position: absolute;
    z-index: 1;
    top: 41%;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 0.5rem;
    box-sizing: border-box;
    max-height: 60%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end !important;
    .time {
      padding: 1.5rem 0.8rem 0rem;
      font-size: 0.8rem;
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    .text {
      font-size: 0.9rem;
      padding: 0.4rem 0.8rem;
      width: 100%;
      height: auto;
      background: linear-gradient(to bottom, #2b1917, #0b0c10);
      word-break: break-all;
      box-sizing: border-box;
    }
    .body {
      padding: 0 0.8rem;
      font-size: 1.2rem;
      width: 100%;
      height: auto;
      word-break: break-all;
      box-sizing: border-box;
    }
  }
}
</style>
